import { defineStore, storeToRefs } from "pinia";
import { computed, ref } from "vue";
import appApi from "@/services/api";
import { exceptionRequestMsg, showToast } from "@/assets/js/util";
import { useRouter } from "vue-router";
import { useGeneralStore } from "@/store/general";
import useUtil from "@/composables/useUtil";

const useStoreCotizaciones = defineStore("cotizaciones", () => {
  const { baseURL } = useUtil();
  const router = useRouter();
  const consultandoInfo = ref(true);
  const btnCargando = ref(false);

  const clientes = ref([]);
  const enganches = ref([]);
  const residuales = ref([]);
  const arrendamientos = ref([]);

  const cliente = ref("");
  const enganche = ref("");
  const residual = ref("");
  const arrendamiento = ref("");
  const importe = ref("");
  const rentas = ref("");
  const seguro = ref("");
  const linea = ref("");
  const moneda = ref("");
  const descripcion = ref("");
  const mostrarRedireccion = ref(true);
  const incluyeSeguro = ref(false);

  const plazo12 = ref("12");
  const plazo24 = ref("24");
  const plazo36 = ref("36");
  const plazo48 = ref("48");
  const plazo60 = ref("60");

  const plazos = [12, 24, 36, 48, 60]; // Definimos los plazos aquí
  const stateCotizacionEditable = ref(
    plazos.map((plazo) => ({
      plazo,
      desembolso_inicial_neto: 0,
      renta_mensual: 0,
      valor_residual_neto: 0,
      ahorro_isr: 0,
    }))
  );

  const plazoTotal = () => {
    const t = `${plazo12.value}${plazo24.value}${plazo36.value}${plazo48.value}${plazo60.value}`;
    return t;
  };

  const labelRedirige = computed(() => {
    return mostrarRedireccion.value ? "" : "&redirect=false";
  });

  const fetchFormInfoCotizacion = async () => {
    consultandoInfo.value = true;
    try {
      const response = await appApi().get("cotizaciones");
      clientes.value = response.data.clientes;
      enganches.value = response.data.enganches;
      arrendamientos.value = response.data.arrendamientos;
      residuales.value = response.data.residuales;
      consultandoInfo.value = false;
    } catch (e) {
      console.error(e);
      exceptionRequestMsg(e);
    }
  };

  const submitCotizacion = async () => {
    btnCargando.value = true;
    try {
      const form = document.getElementById("formCotizacion");
      const formData = new FormData(form);

      formData.append("user_id", localStorage.getItem("_id"));
      formData.append("cliente", cliente.value.id);
      formData.append("incluye_seguro", incluyeSeguro.value);
      const response = await appApi().post(`cotizaciones/store`, formData);
      const { status, message, cotizacion } = response.data;

      if (!status) {
        showToast(message, "error");
        return;
      }

      showToast(message, "success");
      form.reset();

      router.push({
        name: "cotizacion-rapida-show",
        params: {
          token: cotizacion.token,
        },
        query: {
          plazo: plazoTotal(),
        },
      });
    } catch (e) {
      console.log(e);
      exceptionRequestMsg(e);
    } finally {
      btnCargando.value = false;
    }
  };

  const fetchCotizacionByToken = async (token) => {
    try {
      const response = await appApi().get(`cotizaciones/show/${token}`);
      console.log(response);
    } catch (e) {
      exceptionRequestMsg(e);
    }
  };

  const cambiarValorIncluyeSeguro = () => {
    if (arrendamiento.value == 2) {
      incluyeSeguro.value = true;
    } else {
      incluyeSeguro.value = false;
    }
  };

  const urlCotizacionPreview = (token) => {
    return `${
      baseURL.value
    }public/cotizaciones/${token}/preview/?plazo=${plazoTotal()}`;
  };

  return {
    // Arreglos
    clientes,
    enganches,
    residuales,
    arrendamientos,
    stateCotizacionEditable,

    // v-Models
    cliente,
    enganche,
    residual,
    arrendamiento,
    importe,
    rentas,
    seguro,
    linea,
    moneda,
    descripcion,
    mostrarRedireccion,
    incluyeSeguro,

    // General
    btnCargando,

    // Computed
    labelRedirige,

    // Funciones
    cambiarValorIncluyeSeguro,
    fetchFormInfoCotizacion,
    fetchCotizacionByToken,
    submitCotizacion,
    urlCotizacionPreview,
    consultandoInfo,
    plazo12,
    plazo24,
    plazo36,
    plazo48,
    plazo60,
    plazoTotal,
  };
});

export default useStoreCotizaciones;
